import React, { Fragment } from 'react';

import { token } from '@atlaskit/tokens';

import type { GroupedColorTable } from './types';

export const SEMANTIC_CHART_TOKENS: GroupedColorTable = {
	success: [
		{
			name: 'color.chart.success',
			description: (
				<Fragment>
					For data visualization communicating positive information, such as 'on track' or done.
				</Fragment>
			),
			token: token('color.chart.success'),
		},
		{
			name: 'color.chart.success.bold',
			description: (
				<Fragment>
					For data visualization communicating positive information, such as 'on track' or done.
				</Fragment>
			),
			token: token('color.chart.success.bold'),
		},
	],
	warning: [
		{
			name: 'color.chart.warning',
			description: (
				<Fragment>
					For data visualization communicating caution, such as 'at risk' or 'medium priority'.
				</Fragment>
			),
			token: token('color.chart.warning'),
		},
		{
			name: 'color.chart.warning.bold',
			description: (
				<Fragment>
					For data visualization communicating caution, such as 'at risk' or 'medium priority'.{' '}
				</Fragment>
			),
			token: token('color.chart.warning.bold'),
		},
	],
	danger: [
		{
			name: 'color.chart.danger',
			description: (
				<Fragment>
					For data visualization communicating negative or critical information, such as 'off track'
					or 'high priority'.
				</Fragment>
			),
			token: token('color.chart.danger'),
		},
		{
			name: 'color.chart.danger.bold',
			description: (
				<Fragment>
					For data visualization communicating negative or critical information, such as 'off track'
					or 'high priority'.
				</Fragment>
			),
			token: token('color.chart.danger.bold'),
		},
	],
	information: [
		{
			name: 'color.chart.information',
			description: (
				<Fragment>
					For data visualization communicating low priority or in-progress statuses.
				</Fragment>
			),
			token: token('color.chart.information'),
		},
		{
			name: 'color.chart.information.bold',
			description: (
				<Fragment>
					For data visualization communicating low priority or in-progress statuses.
				</Fragment>
			),
			token: token('color.chart.information.bold'),
		},
	],
	discovery: [
		{
			name: 'color.chart.discovery',
			description: <Fragment>For data visualization communicating 'new' statuses.</Fragment>,
			token: token('color.chart.discovery'),
		},
		{
			name: 'color.chart.discovery.bold',
			description: <Fragment>For data visualization communicating 'new' statuses.</Fragment>,
			token: token('color.chart.discovery.bold'),
		},
	],
	neutral: [
		{
			name: 'color.chart.neutral',
			description: <Fragment>For data visualization communicating 'to-do' statuses.</Fragment>,
			token: token('color.chart.neutral'),
		},
	],
};
